import { Directive } from '@angular/core';
import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator} from '@angular/forms';
import {passwordValidator} from '../validators/passwordValidator';

@Directive({
  selector: '[appPasswordValidationDirective]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PasswordValidationDirective,
      multi: true
    }
  ]
})
export class PasswordValidationDirective implements Validator {

    validate(control: AbstractControl): ValidationErrors | null {
        return passwordValidator()(control);
    }

}
